<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">
        <div class="w-100 row justify-content-center">
          <button @click="submitGameTab" type="button" class="btn btn-primary btn-blue col-lg-2">ثبت</button>
        </div>
    </form>
</div>

</template>

<script>


export default {
  name: 'formData',
  components: {
  },
  props: {
  },
  data() {
    return {

    }
  },

  computed: {

  },

  created() {
  },

  mounted () {
  },

  watch: {

  },

  methods: {
    submitGameTab(){
      const cup_id           = this.$route.params.cup_id;
      const state_active_tab = this.$route.params.state_active_tab;
      const paramsData       = {
        cup_id:cup_id,
        // state_active_tab:state_active_tab,
        url : '',
      }

      localStorage.setItem("singleGameTabData", JSON.stringify(paramsData));
      this.$router.push({name:'entryTabScorersAndKnockoutAndGroup', params:paramsData } )
    },



  },

}
</script>
